// src/pages/Contact.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Form from '../components/contact/Form';

function Contact() {
  return (
    <div>
      <Helmet>
        <title>Contato | VitaLink</title>
        <meta name="description" content="Fale com a VitaLink para contratar seu plano de internet fibra óptica e receber suporte rápido da nossa equipe local." />
        <meta name="keywords" content="contato VitaLink, suporte internet, contratar internet fibra óptica" />
        <meta name="author" content="VitaLink" />
        <link rel="canonical" href="https://vitalink.com.br/contact" />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contato | VitaLink" />
        <meta property="og:description" content="Tire suas dúvidas e contrate o plano ideal com atendimento rápido no WhatsApp." />
        <meta property="og:url" content="https://vitalink.com.br/contact" />
        <meta property="og:image" content="https://vitalink.com.br/logo512.png" />
      </Helmet>
      <Form />
    </div>
  );
}

export default Contact;
